class PageDrawer extends HTMLElement {
  connectedCallback() {
    if(!this.parentNode.isEqualNode(document.querySelector('body'))) {
      document.querySelector('body').append(this);
    }
    this.id = this.dataset.drawerId;
    this.drawerStart = this.dataset.drawerStart ?? '-100%';
    this.drawerEnd = this.dataset.drawerEnd ?? '0';
    if(!this.id) {
      throw new Error('Page drawer ID is required.');
    }
    this.hasOverlay = this.hasAttribute('data-include-overlay');
    this.addEventListener('keyup', (
      evt
    ) => evt.target === this && evt.code === 'Escape' && this.close(evt));
    const openTriggers = document.querySelectorAll(`[data-open-drawer="${this.id}"]`);
    openTriggers.forEach(trigger => trigger.addEventListener('click', this.open.bind(this)));
    const closeTriggers = this.querySelectorAll(`[data-close-drawer="${this.id}"]`);
    closeTriggers.forEach(trigger => trigger.addEventListener('click', this.close.bind(this)));
    const state = this.dataset.drawerState;
    if(!state || (state !== 'closed' && state !== 'open')) {
      this.state = 'closed';
      this.close();
    }
    else {
      if(state === 'closed') {
        this.close();
      }
      else {
        this.open();
      }
    }
  }

  set state(value) {
    this.setAttribute('data-drawer-state', value);
  }

  get state() {
    return this.dataset.drawerState;
  }

  close(event) {
    event && event.preventDefault();
    const scrollSmoother = ScrollSmoother.get();
    scrollSmoother?.paused(false)
    this.state = 'closed';
    this.style.transform = `translateX(${this.drawerStart})`;
    if(!document.querySelector('page-drawer[data-drawer-state=open]')) {
      setTimeout(() => {
        // document.documentElement.style.scrollbarGutter = 'stable'
        document.documentElement.style.overflow = 'auto';
      }, 50) 
    }
    if(this.hasOverlay) {
      const overlay = document.getElementById(`overlay-${this.id}`);
      if(overlay) {
        document.body.removeChild(overlay)
      }
    }
    const boundDrawers = document.querySelectorAll(`page-drawer[data-drawer-bound="${this.id}"][data-drawer-state="open"]`);
    boundDrawers.forEach(drawer => {
      if(drawer.id) {
        drawer.close()
      }
    });
  }

  open(event) {
    // const existing = document.querySelectorAll('[data-drawer-state="open"]');
    // existing.forEach(i => !i.isEqualNode(this) && i.close());
    const scrollSmoother = ScrollSmoother.get();
    scrollSmoother?.paused(true)
    event && event.preventDefault();
    this.state = 'open';
    this.style.transform = `translateX(${this.drawerEnd})`;
      setTimeout(() => {
        // document.documentElement.style.scrollbarGutter = 'auto';
        document.documentElement.style.overflow = 'hidden';
      }, 400)
    if(this.hasOverlay && !document.getElementById(`overlay-${this.id}`)) {
      const overlay = document.createElement('div');
      overlay.style.opacity = 0;
      overlay.setAttribute('id', `overlay-${this.id}`);
      overlay.setAttribute('class', this.dataset.includeOverlay);
      document.body.insertBefore(overlay, this)
      overlay.addEventListener('click', this.close.bind(this));
      setTimeout(() => {
        overlay.style.opacity = 1;
      }, 50)
    }
  }
}

customElements.define('page-drawer', PageDrawer);